/* eslint-disable react/jsx-key */

import {TableOutlined} from '@ant-design/icons'

export default [
    [
        'SHEET',
        '表格',
        <TableOutlined />
    ],
]
